<template>
  <div v-frag>
    <div class="roadblock">
      <div class="roadblock-content">
        <div class="cta">
          <img src="~/static/appsumo-plus-white.svg" alt="">
          <h5>
            Join the club.<br>
            Get free tools.
          </h5>
          <p>
            Get KingSumo, SendFox, EmailBadge, ShortySMS and SleekBio for free — plus
            10% off every deal in the store.
          </p>
          <div class="buttons">
            <a
              class="button"
              :href="join"
            >
              Join now
            </a>
            <a
              class="button secondary"
              :href="url"
            >
              See all perks
            </a>
          </div>
          <span class="join">Just $99/year - Cancel anytime</span>
        </div>
        <div class="image">
          <img
            src="~/static/join-plus-1.png"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import frag from 'vue-frag';

export default {
  directives: { frag },
  computed: {
    utmSource() {
      return this.$route.query.utm_source;
    },
    utmCampaign() {
      return this.$route.query.utm_campaign;
    },
    utmMedium() {
      return this.$route.query.utm_medium;
    },
    url() {
      const utm = {
        utm_source: this.utmSource,
        utm_campaign: this.utmCampaign,
        utm_medium: this.utmMedium,
      };
      const params = this.formatParams(utm);

      if (params.length) {
        return `/plus?${params.join('&')}`;
      }

      return '/plus/';
    },
    join() {
      const utm = {
        utm_source: this.utmSource,
        utm_campaign: this.utmCampaign,
        utm_medium: this.utmMedium,
      };
      const params = this.formatParams(utm);

      if (params.length) {
        return `/products/plus-2019/buy/?${params.join('&')}`;
      }

      return '/products/plus-2019/buy/';
    },
  },
  methods: {
    formatParams(utmObj) {
      return Object.entries(utmObj).reduce((m, [k, v]) => {
        if (v) {
          m.push(`${k}=${v}`);
        }

        return m;
      }, []);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.roadblock {
  background: #ff5732;
  margin-left: -30px;
  margin-right: -30px;
  margin-bottom: 60px;
  padding: 32px 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-image: url(~/static/email-plus-blob-1.svg);
  background-repeat: no-repeat;
  background-size: 760px 557px;
  background-position: -102px -38px;
}

.roadblock-content {
  align-items: center;
  flex-direction: row;
  display: flex;
  margin: 0 auto;
  max-width: 1140px;
}

.roadblock.alternate {
  background-image: url(~/static/email-plus-blob-2.svg);
  background-size: 746px 713px;
  background-position: -100px center;
}

.image {
  flex: 1 0 0;
  padding-left: 16px;
  text-align: right;
}

.image img {
  max-height: 320px;
}

.success {
  background: #0a840a;
  padding: 16px 20px;
  color: #fff;
  display: inline-flex;
  align-items: center;
}

.success img {
  margin-right: 16px;
}

.cta {
  flex: 1 0 0;
}

.cta img {
  height: 16px;
  margin-bottom: 16px;
}

.cta .buttons {
  margin-bottom: 16px;
}

.cta span {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
}

.cta h5 {
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  font-family: Barlow, sans-serif;
  color: #fff;
}

.cta p {
  font-size: 16px;
  line-height: 24px;
  color: #fff;
}

.cta input {
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #000;
  font-size: 16px;
  padding: 6px 12px;
  width: 285px;
}

.cta .button {
  background: #ffbc00;
  border-radius: 40px;
  color: #1b1b1b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 24px;
  text-decoration: none;
  border: 0;
  display: inline-block;
  text-align: center;
}

.cta .button.secondary {
  background: #0044c0;
  color: #fff;
  margin-left: 8px;
}

.cta .button:focus {
  border: 0;
  outline: none;
}

@include media-breakpoint-down(xs) {
  .roadblock {
    flex-direction: column;
    background-size: 612px 449px;
    background-position: center 280px;
  }

  .roadblock-content {
    flex-direction: column;
    max-width: unset;
    margin: unset;
  }

  .roadblock.alternate {
    background-position: center 180px;
  }

  .cta {
    order: 2;
  }

  .button {
    width: 100%;
  }

  .button.secondary {
    display: none;
  }

  .image {
    order: 1;
    margin-bottom: 16px;
  }

  .image img {
    margin: 0 auto;
    display: block;
    width: 100%;
  }
}

@include media-breakpoint-down(sm) {
  .roadblock {
    margin-left: -20px;
    margin-right: -20px;
    padding: 32px;
  }

  .cta h5 {
    font-size: 28px;
    line-height: 32px;
  }
}

@include media-breakpoint-down(lg) {
  .cta input {
    width: 100%;
  }

  .cta button {
    margin: 16px 0 0;
    width: 100%;
  }
}
</style>
